import { useMutation, useQueryClient } from '@tanstack/react-query';
import PromptService from '../../../services/prompt-service';
import type {
  ConversationPost,
  ConversationResponse,
} from '../../../types/agent';

const useAddToConversation = ({
  promptId,
  onSuccess,
}: {
  promptId: string;
  onSuccess: (data: ConversationResponse) => void;
}) => {
  const queryClient = useQueryClient();

  return useMutation<ConversationResponse, Error, ConversationPost>({
    mutationFn: async (newPosts) => {
      const data = await PromptService.addToConversation(
        parseInt(promptId),
        newPosts
      );
      return data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['prompt', promptId] });
      onSuccess?.(data);
    },
    onError: (error) => {
      console.error('Failed to add to conversation:', error);
    },
  });
};

export default useAddToConversation;
